export default "__VITE_ASSET__xjxN3pnE__"